import Container from '~/core/ui/Container';
import Heading from '~/core/ui/Heading';
import SubHeading from '~/core/ui/SubHeading';

import configuration from '~/configuration';
import Button from '~/core/ui/Button';

export const meta = () => {
  return [
    {
      title: `Contact Us - ${configuration.site.siteName}`,
    },
  ];
};

export const cardClassName =
  ' option bg-gray-100 dark:bg-gray-800/30 rounded-md p-6 hover:shadow-lg transition-shadow duration-300 ';

export function HelpAndSupportCard() {
  return (
    <div className={cardClassName}>
      <h3 className="text-xl font-semibold mb-4 text-gray-700 dark:text-gray-200">
        Help & support
      </h3>
      <p className="mb-4 text-gray-600 dark:text-gray-300">
        Ask product questions, report problems, or leave feedback.
      </p>
      <Button
        href="mailto:hello@faithgpt.io"
        variant="outline"
        className="rounded-3xl"
      >
        Contact Support
      </Button>
    </div>
  );
}

export function FAQCard() {
  return (
    <div className={cardClassName}>
      <h3 className="text-xl font-semibold mb-4 text-gray-700 dark:text-gray-200">
        Frequently asked questions
      </h3>
      <p className="mb-4 text-gray-600 dark:text-gray-300">
        Chances are we've already answered your question. If we haven't, get in
        touch with us.
      </p>
      <Button href="/faq" variant="outline" className="rounded-3xl">
        Check out our FAQ
      </Button>
    </div>
  );
}

function Contact() {
  return (
    <Container>
      <div className={'flex flex-col space-y-8 my-8'}>
        <div className={'flex flex-col items-center space-y-4'}>
          <Heading>We'd love to help!</Heading>
          <SubHeading className="max-w-xl text-center">
            Get in touch with our support team for help with your account,
            onboarding support, or product questions.
          </SubHeading>
        </div>

        <div className="p-6 mb-16">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <FAQCard />

              <HelpAndSupportCard />
            </div>

            {false && (
              <div className="mt-8">
                <h3 className="text-xl font-semibold mb-4 text-gray-700 dark:text-gray-200">
                  Join the community
                </h3>
                <p className="mb-4 text-gray-600 dark:text-gray-300">
                  More than 9,000 FaithGPT users share questions and best
                  practices in our community.
                </p>
                <button className="text-indigo-600 hover:text-indigo-800 dark:hover:text-indigo-400 transition-colors duration-300">
                  Join Slack
                </button>
              </div>
            )}

            {false && (
              <div className="mt-8">
                <h3 className="text-xl font-semibold mb-4 text-gray-700 dark:text-gray-200">
                  General communication
                </h3>
                <p className="mb-4 text-gray-600 dark:text-gray-300">
                  For other queries, please get in touch with us via email.
                </p>
                <p className="text-indigo-600 hover:text-indigo-800 dark:hover:text-indigo-400 transition-colors duration-300">
                  hello@faithgpt.app
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
}

export default Contact;
